import Templates from './Templates/Index.svelte';
import EmailBuilder from './EmailBuilder/Builder.svelte';
import MarketingPropertyPicker from './Common/MarketingPropertyPicker.svelte';
import SubscriberLists from './SubscriberLists/Index.svelte';
import CampaignLists from './CampaignLists/Index.svelte';
import Campaign from './Campaign/Index.svelte';
import MessageCampaign from './Campaign/Messages/Index.svelte';
import NewListPopup from './Popups/NewList.svelte';
import Dashboard from './Dashboard/Overview.svelte';
import Contacts from './Contacts/Index.svelte';
import CampaignOverview from './Dashboard/Campaign.svelte';
import MessageCampaignOverview from './Dashboard/MessageCampaign.svelte';
import MarketingSettings from './MarketingSettings/Index.svelte';
import AutomationsList from './AutomationsList/Index.svelte';
import Automation from './Automation/Index.svelte';
import ListPicker from './Popups/ListPicker.svelte';
import System from './Templates/System.svelte';
import Property from './CRM/Property.svelte';
import PeriodPicker from './Common/PeriodPicker.svelte';
import VisitorStats from './Funnels/VisitorStats.svelte';
import VariantStats from './Funnels/VariantStats.svelte';
import { QuizWidgetApi } from './BuilderWidgets/QuizWidget';
import { screenshot } from './Common/tools';
import { AppState } from './stores';
import { StoreApi } from './Store';
import BarclaysTransactions from './Store/BarclaysTransactions.svelte';
import { M, resolveExternalDependencies } from './external';
import { showStripeUpgradePrompt } from './Popups/StripeUpgradePrompt.svelte';
import { showAiTextCompletionOptions } from './Common/AiTextCompletionOptions.svelte';
import { showWebsiteList } from './Websites/WebsitePicker.svelte';
import {chooseVideo as chooseVideoWidget, listVideos} from "./Video/VideoService.svelte";
import {editVideoProperties as editVideo } from './Video/Admin/VideoProperties.svelte';
import {embeddedVideoURL, getVideoMetadataById, getVideoService, VIDEO_SERVICE_URL} from "./Video/static";
import Contact from './Contact/Contact.svelte';
import { editEmail } from './CRM/Popups/EmailEditor.svelte';
import { editWhatsApp } from "./CRM/Popups/messages/WhatsAppEditorPopup.svelte";
import { editSMS } from "./CRM/Popups/messages/SMSEditorPopup.svelte";
import { editVoice } from "./CRM/Popups/messages/VoiceEditorPopup.svelte";
import { REGULAR, AB_CONTENT, AB_SUBJECT, SMS, WHATSAPP, VOICE } from './Campaign/static';
import CommentModeration from './CommentModeration/Index.svelte';
import { WallsWidgetApi } from './BuilderWidgets/WallsWidget';
import { CommentWidgetApi } from './BuilderWidgets/CommentWidget';
import { ProductReviewWidgetApi } from './BuilderWidgets/ProductReviewWidget';
import { DiscussionWidgetApi } from './BuilderWidgets/DiscussionWidget';
import {LmsApi} from "./LMS";
import LmsListSettings from './BuilderWidgets/LmsListWidget/LmsListSettings.svelte';
import BillingPage from './Billing/BillingPage.svelte';
import LmsWidgetSettings from './BuilderWidgets/LmsWidget/LmsWidgetSettings.svelte';
import { showActivateAddonUI } from './Billing/Addons/addons';
import Moderation from './CommentModeration/Moderation.svelte';
import { openImageEditor } from './ImageEditor/ImageEditor.svelte';

const API = {
  State: () => {
    return AppState;
  },
  Contact: {
    create: (target, id, onComponentReady) => {
      return new Contact({
        target: target,
        props: {
          id: id,
          onComponentReady: onComponentReady
        }
      });
    }
  },
  CRM: {
    Property: (target, property) => {
      return new Property({
        target: target,
        props: {
          property: property
        }
      });
    },
    composeEmail: (contact) => {
      editEmail(contact);
    },
    composeSMS: (contact) => {
      editSMS(contact);
    },
    composeWhatsApp: (contact) => {
      editWhatsApp(contact);
    },
    composeVoice: (contact) => {
      editVoice(contact);
    }
  },
  BuilderWidgets: {
    Quiz: QuizWidgetApi,
    Walls: WallsWidgetApi,
    Comment: CommentWidgetApi,
    ProductReview: ProductReviewWidgetApi,
    Discussion: DiscussionWidgetApi,
    LmsListWidget: {
      Settings: (target, options) => {
        return new LmsListSettings({
          target: target,
          props: options
        })
      }
    },
    LmsWidget: {
      Settings: (target, options) => {
        return new LmsWidgetSettings({
          target: target,
          props: options
        })
      }
    }
  },
  Marketing: {
    templates: (target, enableTooltip, onTabChange) => {
      return new Templates({
        target: target,
        props: {
          change: onTabChange,
          tooltip: enableTooltip
        }
      });
    },
    builder: (target, data, meta, options, onChange) => {
      return new EmailBuilder({
        target: target,
        props: {
          editorData: data,
          meta: meta,
          options: options,
          onChange: onChange
        }
      });
    },
    pickProperty: (target, extraTags, onClick) => {
      return new MarketingPropertyPicker({
        target: target,
        props: {
          extraTags: extraTags,
          onClick: onClick
        }
      });
    },
    subscriberLists: (target, data) => {
      return new SubscriberLists({
        target: target,
        props: {
          data: data
        }
      });
    },
    settings: (target) => {
      return new MarketingSettings({
        target: target,
        props: {}
      });
    },
    campaignList: (target) => {
      return new CampaignLists({
        target: target
      });
    },
    campaign: (target, data) => {
      return new Campaign({
        target: target,
        props: {
          data: data
        }
      });
    },
    messageCampaign: (target, data) => {
      return new MessageCampaign({
        target: target,
        props: {
          data: data
        }
      });
    },
    automationsList: (target) => {
      return new AutomationsList({
        target: target,
        props: {}
      });
    },
    automation: (target, data) => {
      return new Automation({
        target: target,
        props: {
          data: data
        }
      });
    },
    newListPopup: (target, data) => {
      return new NewListPopup({
        target: target,
        props: {
          data: data
        }
      });
    },
    dashboard: (target, data) => {
      return new Dashboard({
        target: target,
        props: {
          data: data
        }
      });
    },
    screenshot: (options) => {
      return screenshot(options);
    },
    contacts: (target) => {
      return new Contacts({
        target: target,
        props: {}
      });
    },
    campaignOverview: (target, data) => {
      return new CampaignOverview({
        target: target,
        props: {
          data: data
        }
      });
    },
    messageCampaignOverview: (target, data) => {
      return new MessageCampaignOverview({
        target: target,
        props: {
          data: data
        }
      });
    },
    CampaignTypes: { //TODO is this the best way??
      REGULAR: REGULAR,
      AB_CONTENT: AB_CONTENT,
      AB_SUBJECT: AB_SUBJECT,
      SMS: SMS,
      WHATSAPP: WHATSAPP,
      VOICE: VOICE
    },
    listPicker: (target, data, newListButton, message) => {
      return new ListPicker({
        target: target,
        props: {
          data: data,
          showNewListButton: newListButton,
          message: message || M.CHOOSE_SUBSCRIBER_LIST
        }
      });
    },
    systemTemplates: (target) => {
      return new System({
        target: target
      });
    }
  },
  ImageEditor: {
    open: (options) => {
      openImageEditor(options);
    }
  },
  Common: {
    showAiTextCompletionOptions: (target, options) => {
      showAiTextCompletionOptions(target, options);
    },
    periodPicker: (target, initialPeriod) => {
      return new PeriodPicker({
        target: target,
        props: {
          period: initialPeriod
        }
      });
    }
  },
  ECommerce: {
    listBarclaysTransactions: (target) => {
      return new BarclaysTransactions({
        target: target
      });
    }
  },
  LMS: LmsApi,
  Store: StoreApi,
  Funnels: {
    Stats: {
      visitors: (target, funnel, period) => {
        return new VisitorStats({
          target: target,
          props: {
            period: period,
            funnel: funnel
          }
        });
      },
      singleVariant: (target, funnel, variantIds, period) => {
        return new VariantStats({
          target: target,
          props: {
            period: period,
            funnel: funnel,
            variantIds: variantIds
          }
        });
      }
    }
  },
  Websites: {
    listWebsites: (title, message, websites, onSelect) => {
      showWebsiteList(title, message, websites, onSelect);
    }
  },
  VideoService: {
    listVideos: () => {
      listVideos();
    },
    videoPicker: (callback, showSelectFolder = false) => {
      chooseVideoWidget(callback, showSelectFolder);
    },
    editVideo: editVideo,
    getVideoService: getVideoService,
    getVideoMetadataById: getVideoMetadataById,
    embeddedVideoURL: embeddedVideoURL,
    URL: VIDEO_SERVICE_URL
  },
  onDocumentReady: () => {
    resolveExternalDependencies();
  },
  showStripeUpgradePrompt: () => {
    showStripeUpgradePrompt();
  },
  showAddonUpgradePrompt: async (type, manuallyActivatedMessage) => {
    return await showActivateAddonUI(type, null, true, manuallyActivatedMessage);
  },
  showBillingPage: (target) => {
    return new BillingPage({
      target: target,
      props: {}
    })
  },
  destroy: (component) => {
    if (component && component.$destroy) {
      component.$destroy();
    }
  },
  CommentModeration: {
    render: function (target, props, onComponentReady) {
      return new CommentModeration({
        target: target,
        props: {
          ...props,
          onComponentReady
        }
      });
    },
    renderStandalone: function (target, props, onComponentReady) {
      return new Moderation({ target: target, props: { ...props, onComponentReady } });
    }
  }
};

export default API;
